import React, { useState, useEffect } from 'react';
import * as kpi from '../../../services/kpisServices.js'
import ChildsModal from '../Modal/ChildsModal.jsx';
import Table from './Table.jsx';
import { toast } from 'react-toastify';
import Loading from '../../../components/loading/Loading.jsx';
import GaugeComponent from 'react-gauge-component'
import { LoadingOutlined } from '@ant-design/icons';
import {Space,Spin} from 'antd';

const  ProgressChart=({dataChart=[],stId,cycle})=> {
   const [arrayChart, setArrayChart] = useState([]);
   const [counterMessage, setCounterMessage] = useState(0);
    useEffect(() => {
        if(dataChart.length!==0)
            setArrayChart(dataChart);
   }, [dataChart,stId,cycle]);
   
    // useEffect(() => {
    // if(arrayChart.length===counterMessage && counterMessage!==0)
    //     toast.warning('No se encontraron datos');
    // },[counterMessage])

    const summCounter=()=>{
        setCounterMessage(counterMessage+1);
        if(arrayChart.length===counterMessage)
        {
            toast.warning('No se encontraron datos');
        }
        
    }
    return ( 
        <div className='row'>
            {
                arrayChart?.map((item) => (
                        <Chart key={item.id} data={item}  cycle={cycle} stId={stId? stId: item.structureCode} increaseCounter={()=>summCounter()} />
                ))
            }
        </div>
     );
}

const Chart=({data,stId,cycle,increaseCounter})=>{
   
    const [indicatorsData, setIndicatorsData] = useState({});
    const [toggle, setToggle] = useState(false);
    const [childrenData, setChildrenData] = useState([]);
    const [toggleTable, setToggleTable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingChild, setLoadingChild] = useState(false);
    
    
   useEffect(() => {
    const getDataIndicator = async (indicatorId) => {
        try {
            setLoading(true);
            const response = await kpi.getDataIndicator(indicatorId, cycle, stId);
            if (response.status === 200) {
                setIndicatorsData(response.data);
            }else{
                // increaseCounter();
               
            }
            setLoading(false);
        } catch (error) {
           console.log(error);
           setLoading(false);

        }
    }
    getDataIndicator(data.id);
   }, [cycle, stId]);

   const getChildsData= async(parentData)=>{
    try {
           setLoadingChild(true);
            const response = await kpi.getChildsIndicators(parentData.id, cycle, stId);

            if(response.status===200){
                if(response.data?.isLeaf)
                    {
                        setChildrenData(response.data.composition.sellersComposition)
                        setToggleTable(true);
                    }else{
                        const newArray= response.data.map((item)=>({...item,id:data.id}))
                        setChildrenData(newArray)
                        setToggle(!toggle);
                    }
            }else{
                toast.warning('No se encontraron datos');
            }
           setLoadingChild(false);

        }catch (error) {
            console.log(error);
            setLoadingChild(false);
        }
    }
    return(
        <>
        <Loading toggle={loadingChild}/>
        {loading ? 
        <Space className='container justify-content-center col-md-3 col-6'>
        <Spin wrapperClassName=" align-center"  indicator={
            // <LoadingOutlined style={{ fontSize: 50 , color: 'orange'  }} 
            <i className="fas fa-cog fa-spin fa-10x text-orange" />
        // spin />
        } />
      </Space>
      :<>
        
        
        <div className="col-6 col-md-3 border">

                <div className="widget-card rounded mb-20px " onClick={()=>getChildsData(data)}>
                    <div className="widget-card-content">
                    <h5 className="stats-desc">{data.name} {data?.structureName}</h5>
                    </div>
                    <GaugeComponent
                    type='semicircle'
                   
                     arc={{
                        subArcs: [
                          {
                            // limit: 20,
                            color: '#EA4228',
                            // showTick: true
                          },
                          {
                            // limit: 40,
                            color: '#F58B19',
                            // showTick: true
                          },
                          {
                            // limit: 60,
                            color: '#F5CD19',
                            // showTick: true
                          },
                          {
                            // limit: 100,
                            color: '#5BE12C',
                            // showTick: true
                          },

                        ]
                      }}
                      pointer={{type: 'arrow', 
                                animationDelay:1.5, 
                            }}
                    labels={{
                            valueLabel:{
                            style:{
                                fill:'#000',
                                fontSize: '40px',
                                textShadow: ''
                            }
                             
                            },

                        }
                    }
                      value={indicatorsData?.kpiStructureValues?.objectiveValue!==0 && indicatorsData?.kpiStructureValues?.objectiveValue!==undefined ? (indicatorsData?.kpiStructureValues?.amountRealized*100/indicatorsData?.kpiStructureValues?.objectiveValue).toFixed(2):'0 ' }
                     />
                     
                     <div className="widget-card-content">
                        <b className="stats-desc"> {indicatorsData?.kpiStructureValues?.amountRealized?.toLocaleString('es-MX')} / {indicatorsData?.kpiStructureValues?.objectiveValue?.toLocaleString('es-MX')} {!indicatorsData?.kpiStructureValues?.objectiveValue && 'Sin meta' }</b>
								</div>
                     </div>
                </div>
                <ChildsModal toggle={toggle}  data={childrenData} cycle={cycle} setToggle={()=>setToggle(!toggle)} />
                <Table toggle={toggleTable} data={childrenData} setToggle={()=>setToggleTable(!toggleTable)}/>
                
        </>}</>
    )
}
export default ProgressChart;